(function () {
    const radios = document.querySelectorAll('input[name="supervision-filter"]');
    if (!radios.length) return;

    const section = document.querySelector('.related-groups');
    const emptyMsg = section ? section.querySelector('.filter-empty-message') : null;

    function applyFilter(value) {
        const items = document.querySelectorAll('.related-groups .event-item');
        let visibleCount = 0;

        items.forEach(function (item) {
            let locData = {};
            try { locData = JSON.parse(item.dataset.eventLocdata || '{}'); } catch (e) { /* ignore */ }
            const types = Array.isArray(locData.type) ? locData.type : [];

            const show = value === 'all'
                ? (types.includes('SUP') || types.includes('DGC'))
                : (types.includes('DGC') || types.includes('SUP'));

            item.style.display = show ? '' : 'none';
            if (show) visibleCount++;
        });

        if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
    }

    radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
            applyFilter(this.value);
        });
    });
}());
